// import { ref, computed } from "vue";
import { defineStore } from "pinia";
// import { getContact } from "@/libs/utils";
import {
  getContactInfo,
  defaultTitleGroup,
  getCompanyInfoByUniversalName,
} from "@/api";
import { LinkedinUrl } from "@/config";
import { delayExecution } from "@i.un/libs";

export type ContactType = {
  publicId: string;
  name: string;
  company: string;
  companyUniversalName: string;
  jobTitle: string;
  avatar: string;
  displayPictureUrl: string;
  firstName: string;
  lastName: string;
  email: string;
  emails: string[];
  phone: string;
  phones: string[];
  findEmailFlag: boolean;
  findPhoneFlag: boolean;
  phoneQueryStatus: "NOT_QUERIED" | "IN_PROGRESS" | "FOUND" | "NOT_FOUND";
  findKpFlag: boolean;
  historyEmail: {
    sources: string[];
  };
  historyPhone: {
    sources: string[];
  };
  historyKp: {
    records: string[];
  };
} | null;
export const useContactStore = defineStore("contact", {
  state: () => ({
    contactRaw: null as any,
    contact: null as ContactType | null,
    publicId: "" as string,
    stateDefaultTitleGroup: [] as any[],
  }),
  getters: {
    userInfo: (state) => state.contact,
    gettersDefaultTitleGroup: (state) => state.stateDefaultTitleGroup,
  },
  actions: {
    getContact(publicId: string): Promise<ContactType | null> {
      // if (this.publicId == publicId && this.contact)
      //   return Promise.resolve(this.contact);
      this.publicId = publicId;
      // let fun =
      //   (window as any).location.protocol === "chrome-extension:"
      //     ? getContact
      //     : getContactApi;
      // const params: any = { publicId };
      // if (companyUniversalName) {
      //   params.companyUrl = LinkedinUrl + "/company/" + companyUniversalName;
      // }
      return getContactInfo(publicId).then(async (res: any) => {
        if (res.code === 200) {
          // if(!res.data.firstName && !res.data.lastName){
          //   console.log("no firstName or lastName, retry");
          //   return delayExecution(() => this.getContact(publicId), 1000);
          // }
          this.contactRaw = { ...res.data };
          // if (publicId) {
          //   this.contactRaw.displayPictureUrl = await getLinkedinProfilePhoto(
          //     publicId
          //   );
          // }
          // if (publicId && !this.contactRaw.email) {
          //   this.contactRaw.email =
          //     (await getLinkedinProfileEmail(publicId)) || "";
          // }

          const contact = { ...res.data };
          contact.publicId = publicId;
          // contact.name = `${contact.firstName} ${contact.lastName}`;
          // contact.avatar = this.contactRaw.displayPictureUrl;
          // contact.email = this.contactRaw.email;
          // if (contact.companyUrn && !contact.companyUniversalName) {
          //   const companyInfo = await getCompanyInfoByUrn(contact.companyUrn);
          //   // console.log("companyInfo", companyInfo);
          //   if (companyInfo) {
          //     contact.companyUniversalName = companyInfo.data.universalName;
          //     contact.companyUrn = companyInfo.data.urn;
          //     contact.company = companyInfo.data.name;
          //   }
          // } else 
          if (contact.companyUniversalName) {
            getCompanyInfoByUniversalName(contact.companyUniversalName);
          }
          this.setContact(contact);
        } else {
          this.setContact(null);
        }
        return this.contact;
      });
    },

    setContact(contact?: any) {
      if (contact) {
        this.publicId = contact.publicId;
        this.contact = contact;
      } else {
        this.publicId = "";
        this.contact = null;
        this.contactRaw = null;
      }
    },

    setProfile(profile: any) {
      this.contact = Object.assign(this.contact || {}, profile);
      this.contactRaw = Object.assign(this.contactRaw || {}, profile);
    },

    // 查询全局词库
    async getDefaultTitleGroup() {
      const res = await defaultTitleGroup();
      if (res.code === 200) {
        this.stateDefaultTitleGroup = res.data;
      }
      return res.data;
    },
  },
});
